import { renderBrandLogo } from '~utils/brand'

export const useBrandLogo = renderBrandLogo
